
import WithModel from '@/mixins/withModel';
import * as OM from '@/model'
import { ProjectConfigClient } from '@/services/Services';
import { mixins, Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Options({})
export default class telephone extends mixins(WithModel) {

    @Prop() label: string;

    prefixList: OM.PrefixCountry[] = [];

    created(){
        if(!this.modelValue){
            this.localValue = new OM.Telephone();
            this.emitModel(this.localValue);
        }
        ProjectConfigClient.getPhonePrefixes()
        .then(x => {
            this.prefixList = x;
        })
    }

}
